// Same-day reply promise for quote requests, in the shop's own time zone.
// Enquiries before the cut-off on an open day get an answer the same day;
// later ones are answered first thing on the next open day.
export const REPLY_HOURS = { timeZone: 'Europe/Madrid', openDays: [1, 2, 3, 4, 5, 6], cutoffHour: 18, replyBy: '20:00', nextDayBy: '12:00' };

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function shopClock(date, timeZone) {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone, weekday: 'short', hour: 'numeric', hourCycle: 'h23' }).formatToParts(date);
  const get = type => (parts.find(p => p.type === type) || {}).value;
  return { day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday')), hour: Number(get('hour')) };
}

export function replyPromise(date = new Date(), hours = REPLY_HOURS) {
  const { day, hour } = shopClock(date, hours.timeZone);
  if (hours.openDays.includes(day) && hour < hours.cutoffHour) {
    return { today: true, short: 'Reply today', text: `Send it now and a Velodrom specialist will reply today, before ${hours.replyBy}.` };
  }
  let next = (day + 1) % 7;
  while (!hours.openDays.includes(next)) next = (next + 1) % 7;
  const when = next === (day + 1) % 7 ? 'tomorrow' : `on ${DAYS[next]}`;
  return { today: false, short: `Reply ${when} by ${hours.nextDayBy}`, text: `Send it now and a Velodrom specialist will reply ${when}, before ${hours.nextDayBy}.` };
}
